import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useParams} from 'react-router-dom'

import {withTitle} from '@/router/utils'
import {OutletDetailsContainer} from '@/components'

export const POSOutletDetailsStoreSymbol = Symbol('POSOutletDetailsStoreSymbol')

const POSOutletDetails: React.FC<null> = observer(() => {
    const { t } = useTranslation()
    const {id} = useParams<{id: string}>()

    return (
        <OutletDetailsContainer
            id={id}
            injectableIdentifier={POSOutletDetailsStoreSymbol}
            containerTitle={t('POSOutletDetails.posOutlets')}
        />
    )
})

export default withTitle(POSOutletDetails, 'POSOutletDetails.posOutlets')
